export const sendVideoHeartbeat = {
  id: 'video_heartbeat',
  name: 'Video Heartbeat',
  type: 'video_facts',
  attributes: [
    'entityType',
    'entityId',
    'entityName',
    'viewType',
    'videoId',
    'duration',
    'videoWidth',
    'videoHeight',
    'playerWidth',
    'playerHeight',
    'fullscreen',
    'muted',
    'volume',
    'startTime',
    'endTime',
    'buffering',
    'activeTab'
  ],
  destinations: ['Analytics']
};

export const sendVideoEnd = {
  id: 'video_end',
  name: 'Video End',
  type: 'video_facts',
  attributes: [
    'entityType',
    'entityId',
    'entityName',
    'viewType',
    'videoId',
    'duration',
    'videoWidth',
    'videoHeight',
    'playerWidth',
    'playerHeight',
    'fullscreen',
    'muted',
    'volume',
    'startTime',
    'endTime',
    'buffering',
    'activeTab'
  ],
  destinations: ['Analytics']
};

export const sendVideoStart = {
  id: 'video_start',
  name: 'Video Start',
  type: 'video_facts',
  attributes: [
    'entityType',
    'entityId',
    'entityName',
    'viewType',
    'videoId',
    'duration',
    'videoWidth',
    'videoHeight',
    'playerWidth',
    'playerHeight',
    'fullscreen',
    'muted',
    'volume',
    'startTime',
    'endTime',
    'buffering',
    'activeTab'
  ],
  destinations: ['Analytics']
};
